import { render, staticRenderFns } from "./LifeEventModal.vue?vue&type=template&id=7418f2e6&scoped=true&"
import script from "./LifeEventModal.vue?vue&type=script&lang=js&"
export * from "./LifeEventModal.vue?vue&type=script&lang=js&"
import style0 from "./LifeEventModal.vue?vue&type=style&index=0&id=7418f2e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7418f2e6",
  null
  
)

export default component.exports